module.exports = __webpack_public_path__ + "67bfd6025bbd9e40806abd2caf0bbfef.svg";